/* eslint-disable @typescript-eslint/naming-convention */
import { SlackUserPayloadSchema } from '@weft/types';
import { oz } from '@weft/utils';
import { SlackActionSchema } from './slack-event-handler-action-schema';

export const SlackEventHandlerParsedRequestSchema = oz.object({
  type: oz.string(),
  user: SlackUserPayloadSchema,
  container: oz.object({
    channel_id: oz.string(),
    message_ts: oz.string(),
  }),
  actions: oz.array(SlackActionSchema).optional(),
});

export const SlackEventHandlerRequestSchema = oz.object({
  payload: oz.string(),
})
  .transform((body) => JSON.parse(body.payload))
  .pipe(SlackEventHandlerParsedRequestSchema).openapi('SlackEventHandlerRequest');

export type SlackEventHandlerRequestPayload = oz.infer<typeof SlackEventHandlerRequestSchema>;